// src/components/CriteriaModal.jsx
import React, { useState } from 'react';

const CriteriaModal = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <button
        className="criteria-button"
        onClick={() => setIsOpen(true)}
      >
        КРИТЕРИИ ОЦЕНОК
      </button>

      {isOpen && (
        <div
          className="criteria-overlay"
          onClick={() => setIsOpen(false)}
        >
          <div
            className="criteria-modal"
            onClick={e => e.stopPropagation()}
          >
            <button
              className="criteria-close"
              onClick={() => setIsOpen(false)}
            >
              ×
            </button>

            <h2>Критерии оценки</h2>

            {/* 1 */}
            <div className="criteria-section">
              <h3>1. BrandGlobe Mastermind Grand Prix</h3>
              <p className="criteria-subtitle">Главная награда лидера‑визионера</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Визионерская четкость</td>
                    <td>25</td>
                    <td>
                      Насколько капитан сформулировал понятную «большую идею» бренда, связал её с трендами глобального рынка и показал конечную картину успеха.
                    </td>
                  </tr>
                  <tr>
                    <td>Управление межфункциональной командой</td>
                    <td>20</td>
                    <td>
                      Структура ролей, распределение задач, динамика спринтов, ретроспективы, умение капитана мотивировать и гасить конфликты.
                    </td>
                  </tr>
                  <tr>
                    <td>Архитектура бренда</td>
                    <td>15</td>
                    <td>
                      Целостность платформы (миссия – ценности – тон – визуальный код), наличие brand‑book & design‑system.
                    </td>
                  </tr>
                  <tr>
                    <td>План масштабирования (3+ рынков)</td>
                    <td>15</td>
                    <td>
                      Пошаговый roadmap (12–18 мес.), бюджеты, партнеры, локализационные гипотезы и KPI.
                    </td>
                  </tr>
                  <tr>
                    <td>Финансово‑операционная модель</td>
                    <td>10</td>
                    <td>
                      Unit‑экономика, каналы монетизации, прогноз P&L на два года.
                    </td>
                  </tr>
                  <tr>
                    <td>Личная презентация капитана</td>
                    <td>10</td>
                    <td>Сторителлинг, харизма, работа с вопросами жюри.</td>
                  </tr>
                  <tr>
                    <td>Бонус – Q&A‑сессия</td>
                    <td>+5</td>
                    <td>Глубина ответов на неожиданные вопросы и устойчивость под давлением.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 2 */}
            <div className="criteria-section">
              <h3>2. Cross‑Cultural Navigator Award</h3>
              <p className="criteria-subtitle">Лидер культурной адаптации</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Глубина культурного ресерча</td>
                    <td>25</td>
                    <td>
                      Desk‑ и field‑исследования, верификация инсайтов носителями языка, работа с антропологами.
                    </td>
                  </tr>
                  <tr>
                    <td>Локализация визуального и вербального кода</td>
                    <td>20</td>
                    <td>
                      Цвет, типографика, символика, копирайт – соответствуют нормам трёх целевых культур.
                    </td>
                  </tr>
                  <tr>
                    <td>Мультиязычная контент‑стратегия</td>
                    <td>15</td>
                    <td>
                      Контент‑календарь, подбор каналов, адаптация micro‑ и macro‑форматов под каждую страну.
                    </td>
                  </tr>
                  <tr>
                    <td>Инклюзивное командное взаимодействие</td>
                    <td>10</td>
                    <td>
                      Практики фасилитации, time‑zone‑менеджмент, языковые барьеры, agile‑процессы.
                    </td>
                  </tr>
                  <tr>
                    <td>Локальные тесты и обратная связь</td>
                    <td>10</td>
                    <td>
                      A/B‑пробы, фокус‑группы, корректировки по итогам тестов.
                    </td>
                  </tr>
                  <tr>
                    <td>Soft‑skills капитана</td>
                    <td>15</td>
                    <td>Эмпатия, медиаторские способности, управление межкультурными рисками.</td>
                  </tr>
                  <tr>
                    <td>Бонус – риск‑менеджмент «культурных мин»</td>
                    <td>+5</td>
                    <td>План действий при репутационном кризисе из‑за культурного недопонимания.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 3 */}
            <div className="criteria-section">
              <h3>3. Digital Innovation Trailblazer</h3>
              <p className="criteria-subtitle">Лидер технологического прорыва</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Технологическая новизна</td>
                    <td>25</td>
                    <td>
                      Уникальность стека (AI‑генерация, AR/VR, Web3), патентоспособность решений.
                    </td>
                  </tr>
                  <tr>
                    <td>Связка «технология ↔ ценность бренда»</td>
                    <td>20</td>
                    <td>
                      Как инновация усиливает УТП и пользовательский опыт.
                    </td>
                  </tr>
                  <tr>
                    <td>Тех‑физибилити и roadmap</td>
                    <td>15</td>
                    <td>Архитектура, DevOps‑процессы, таймлайн релизов.</td>
                  </tr>
                  <tr>
                    <td>UX‑прототип (PoC/MVP)</td>
                    <td>15</td>
                    <td>Наглядность сценариев, метрики реагирования юзеров.</td>
                  </tr>
                  <tr>
                    <td>Open‑source/репозиторий</td>
                    <td>10</td>
                    <td>Документация, лицензия, коммиты, CI/CD.</td>
                  </tr>
                  <tr>
                    <td>Governance & безопасность</td>
                    <td>10</td>
                    <td>GDPR/CCPA‑compliance, ethical‑AI чек‑лист, план кибер‑безопасности.</td>
                  </tr>
                  <tr>
                    <td>Бонус – экологичность инфраструктуры</td>
                    <td>+5</td>
                    <td>Серверы с low‑carbon‑footprint, оптимизация запросов.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 4 */}
            <div className="criteria-section">
              <h3>4. Global Vision Grand Prix</h3>
              <p className="criteria-subtitle">Главная командная награда</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Стратегическое позиционирование</td>
                    <td>20</td>
                    <td>
                      Чётко сформулированная ниша, конкурентные отличия, релевантность глобальным трендам и pain‑points аудитории.
                    </td>
                  </tr>
                  <tr>
                    <td>Универсальность визуальной айдентики</td>
                    <td>15</td>
                    <td>
                      Гибкость логотипа, цветовой схемы и типографии для разных медиа и культур; адаптируемость под вертикальное/горизонтальное размещение и монохром.
                    </td>
                  </tr>
                  <tr>
                    <td>Проверка рынка (MVP / опросы / тесты)</td>
                    <td>15</td>
                    <td>
                      Наличие валидированных гипотез: результаты A/B‑тестов, опросов или ранних продаж в 2–3 странах; выводы, повлиявшие на доработку концепта.
                    </td>
                  </tr>
                  <tr>
                    <td>Финансовая модель & монетизация</td>
                    <td>15</td>
                    <td>
                      MRR/ARR‑прогноз, cash‑flow, unit‑экономика, sensitivity‑анализ; реалистичность затрат на масштабирование.
                    </td>
                  </tr>
                  <tr>
                    <td>План глобального роста</td>
                    <td>15</td>
                    <td>
                      Дорожная карта выхода на 3+ рынков (таймлайны, партнёры, юридические и логистические шаги), KPI (CAC, LTV, ROMI).
                    </td>
                  </tr>
                  <tr>
                    <td>Командная синергия</td>
                    <td>10</td>
                    <td>
                      Прозрачное распределение ролей, использование agile/kanban, скорость итераций, внутрикомандное взаимодействие.
                    </td>
                  </tr>
                  <tr>
                    <td>Финальный питч</td>
                    <td>10</td>
                    <td>
                      Структура презентации, сторителлинг, визуальная чистота слайдов, ответы на вопросы жюри и соблюдение тайминга.
                    </td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 5 */}
            <div className="criteria-section">
              <h3>5. Culture Fusion Award</h3>
              <p className="criteria-subtitle">Лучшая культурная адаптация бренда</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Культурный контекст & исследование</td>
                    <td>20</td>
                    <td>
                      Глубина desk‑ и field‑ ресерча: отчёты, интервью, фокус‑группы; корректность трактовки локальных ценностей.
                    </td>
                  </tr>
                  <tr>
                    <td>Языковая гибкость слогана</td>
                    <td>15</td>
                    <td>
                      Переводимость без потери смысла и эмоциональной окраски; наличие word‑play или рифм, работающих в разных языках.
                    </td>
                  </tr>
                  <tr>
                    <td>Визуальная палитра под культуру</td>
                    <td>15</td>
                    <td>
                      Выбор цветов, форм, иконографии с учётом местных ассоциаций, табу и читаемости на разных устройствах.
                    </td>
                  </tr>
                  <tr>
                    <td>Локальные инсайты (humor, традиции, табу)</td>
                    <td>15</td>
                    <td>
                      Корректное использование юмора, мемов, исторических/религиозных символов; проверка кросс‑культурных рисков.
                    </td>
                  </tr>
                  <tr>
                    <td>Этичный сторителлинг</td>
                    <td>10</td>
                    <td>Отсутствие стереотипов, соблюдение DEI‑принципов и прав меньшинств; прозрачность источников контента.</td>
                  </tr>
                  <tr>
                    <td>Тест‑кампании и обратная связь</td>
                    <td>10</td>
                    <td>Результаты локальных soft‑launch, краудсорс‑обратная связь, скорость итераций по итогам фидбэка.</td>
                  </tr>
                  <tr>
                    <td>KPI вовлеченности в регионах</td>
                    <td>15</td>
                    <td>ER, CTR, CR или NPS в каждой культуре; сопоставление с эталоном рынка и выводы по оптимизации.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 6 */}
            <div className="criteria-section">
              <h3>6. Digital Innovation in Branding</h3>
              <p className="criteria-subtitle">Лучшая технологическая новация</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Frontier‑технология</td>
                    <td>20</td>
                    <td>
                      Использование cutting‑edge‑инструментов (AR‑лензы, WebGPU, генеративный AI‑video, NFT‑utility‑tokens); новизна решения на текущем рынке.
                    </td>
                  </tr>
                  <tr>
                    <td>Рост вовлеченности / Retention</td>
                    <td>20</td>
                    <td>
                      Подтверждённый lift по метрикам (DAU/MAU, average session time, repeat purchase) после внедрения технологии.
                    </td>
                  </tr>
                  <tr>
                    <td>Интеграция с ценностью бренда</td>
                    <td>15</td>
                    <td>Логичность связки «технология ↔ эмоциональное и функциональное ядро бренда», отсутствие «технорадиотехно».</td>
                  </tr>
                  <tr>
                    <td>Надёжность и масштабируемость</td>
                    <td>10</td>
                    <td>SLA, производительность на пиковой нагрузке, cross‑platform‑совместимость, возможности локализации.</td>
                  </tr>
                  <tr>
                    <td>Data & Privacy compliance</td>
                    <td>10</td>
                    <td>Соответствие GDPR/CCPA, наличие Privacy by Design, шифрование пользовательских данных.</td>
                  </tr>
                  <tr>
                    <td>Demo / Prototype</td>
                    <td>15</td>
                    <td>Живое демо или интерактивный прототип с описанными user‑flows и логами аналитики.</td>
                  </tr>
                  <tr>
                    <td>Себестоимость внедрения</td>
                    <td>10</td>
                    <td>TCO за 12–24 мес., оценка break‑even‑point, соотношение CAPEX/OPEX.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 7 */}
            <div className="criteria-section">
              <h3>7. Tech Disruptor Brand</h3>
              <p className="criteria-subtitle">Лучший бренд технологического продукта</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Уникальность решения</td>
                    <td>20</td>
                    <td>Технический novelty, конкурентный ландшафт, патентная чистота.</td>
                  </tr>
                  <tr>
                    <td>Ясность УТП</td>
                    <td>15</td>
                    <td>Сформулированная value‑prop «для кого – зачем – почему лучше», подкреплённая pain‑metrics.</td>
                  </tr>
                  <tr>
                    <td>UX / UI‑дизайн</td>
                    <td>15</td>
                    <td>Сценарии, микро‑анимации, доступность (WCAG 2.1), onboarding‑flow.</td>
                  </tr>
                  <tr>
                    <td>Go‑to‑Market roadmap</td>
                    <td>15</td>
                    <td>Стратегия выхода (freemium, channel‑partners, direct sales), вехи и бюджеты.</td>
                  </tr>
                  <tr>
                    <td>Комьюнити‑стратегия</td>
                    <td>10</td>
                    <td>Форумы, Discord/Slack, beta‑тест‑программа, advocacy‑программа.</td>
                  </tr>
                  <tr>
                    <td>MVP доступен</td>
                    <td>10</td>
                    <td>Репозиторий / TestFlight / APK; количество ранних пользователей и их фидбэк.</td>
                  </tr>
                  <tr>
                    <td>Бизнес‑устойчивость</td>
                    <td>10</td>
                    <td>LTV/CAC, churn‑rate прогноз, сценарии финансирования (bootstrapping, VC).</td>
                  </tr>
                  <tr>
                    <td>Бонус – open‑source вклад</td>
                    <td>+5</td>
                    <td>Pull‑requests, issue‑tracker, количество контрибьюторов.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 8 */}
            <div className="criteria-section">
              <h3>8. Fashion & Lifestyle Icon</h3>
              <p className="criteria-subtitle">Лучшая fashion / lifestyle‑концепция</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Эмоциональный сторителлинг</td>
                    <td>20</td>
                    <td>История бренда, архетип, moodboard, связь с ценностями аудитории.</td>
                  </tr>
                  <tr>
                    <td>Визуальный почерк (look & feel)</td>
                    <td>15</td>
                    <td>Уникальные patterns, фотостиль, визуальные референсы.</td>
                  </tr>
                  <tr>
                    <td>Инфлюенсер‑коллаборации</td>
                    <td>10</td>
                    <td>Подбор лидеров мнений, релевантность ЦА, формат (drop, capsule, live‑stream).</td>
                  </tr>
                  <tr>
                    <td>Sustainability / ESG</td>
                    <td>15</td>
                    <td>Использование eco‑fabrics, traceable supply‑chain, carbon‑offset, этичное производство.</td>
                  </tr>
                  <tr>
                    <td>Omni‑канальная стратегия</td>
                    <td>10</td>
                    <td>Seamless переход между e‑commerce, social‑commerce, pop‑ups; возвраты/логистика.</td>
                  </tr>
                  <tr>
                    <td>Virtual Try‑On / digital‑experience</td>
                    <td>10</td>
                    <td>AR‑примерка, 3D‑каталог, персонализация посадки, latency.</td>
                  </tr>
                  <tr>
                    <td>Арт‑стилистика и инновации</td>
                    <td>10</td>
                    <td>Эксперименты с digital couture, 3D‑печать, phygital‑мерч.</td>
                  </tr>
                  <tr>
                    <td>Market‑fit анализ</td>
                    <td>10</td>
                    <td>TAM/SAM/SOM, конкурентная карта, план выхода на fashion‑weeks/шоурумы.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 9 */}
            <div className="criteria-section">
              <h3>9. Social Impact Champion</h3>
              <p className="criteria-subtitle">Лучшая социальная инициатива</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно оцениваем</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Чёткая формулировка проблемы</td>
                    <td>15</td>
                    <td>Обоснование актуальности, размер целевой группы, цифры потерь/ущерба.</td>
                  </tr>
                  <tr>
                    <td>KPI воздействия</td>
                    <td>15</td>
                    <td>Метрики output/outcome/impact, baseline‑данные, SMART‑цели.</td>
                  </tr>
                  <tr>
                    <td>Финансовая устойчивость</td>
                    <td>15</td>
                    <td>Revenue mix (donations, grants, earned income), кэш‑резерв, план диверсификации.</td>
                  </tr>
                  <tr>
                    <td>Партнерства & Stakeholders</td>
                    <td>10</td>
                    <td>NGO, государство, бизнес, академия; уровень участия и распределение ролей.</td>
                  </tr>
                  <tr>
                    <td>Impact‑отчетность</td>
                    <td>10</td>
                    <td>Методология SROI/IRIS+, независимый аудит, публичные отчёты.</td>
                  </tr>
                  <tr>
                    <td>Масштабируемость решения</td>
                    <td>15</td>
                    <td>Возможность тиражирования, стандартизация процессов, tech‑enablement.</td>
                  </tr>
                  <tr>
                    <td>Вовлечение сообщества</td>
                    <td>10</td>
                    <td>Co‑creation, волонтерские программы, краудфандинг.</td>
                  </tr>
                  <tr>
                    <td>Этические стандарты</td>
                    <td>10</td>
                    <td>Safeguarding, data‑protection, инклюзивность, отсутствие «white‑saviour» эффекта.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>

            {/* 10 */}
            <div className="criteria-section">
              <h3>10. Audience Choice Award</h3>
              <p className="criteria-subtitle">Приз зрительских симпатий</p>
              <div className='criteria-table-wrapper'>
              <table className="criteria-table">
                <thead>
                  <tr>
                    <th>Блок</th>
                    <th>%</th>
                    <th>Что именно учитывается</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>Онлайн‑голоса (блокчейн‑валидация)</td>
                    <td>50</td>
                    <td>
                      Число уникальных проверенных голосов, собранных через токенизированный счётчик; защита от ботов.
                    </td>
                  </tr>
                  <tr>
                    <td>Вовлечённость соцсетей</td>
                    <td>30</td>
                    <td>Суммарный Engagement Rate: лайки, комментарии, репосты, watch‑time reels/shorts.</td>
                  </tr>
                  <tr>
                    <td>Креатив 1‑минутного видеопитча</td>
                    <td>20</td>
                    <td>Чёткость месседжа, монтаж, визуальные эффекты, призыв к действию.</td>
                  </tr>
                </tbody>
              </table>
              </div>
            </div>



          </div>
        </div>
      )}
    </>
  );
};

export default CriteriaModal;
